import {fetchModel, fetchModels, postModel} from 'shared/store';
import {auth, endpoints, types} from 'main/tools';
import CheckIn from 'main/stores/performance/CheckIn';
import { makeAutoObservable } from 'mobx';
import {setupAutosaveDraft} from 'main/tools';
import _ from 'lodash';

class MyCheckInResponseContainerState {
  history;
  match;

  checkin;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      history: false
    });
  }

  receiveProps({history, match}) {
    this.history = history;
    this.match = match;
  }

  async load() {
    const {cycleId, reviewerId} = this.match.params;

    const awaitingCheckinId = await this.findAwaitingCheckinId(cycleId, reviewerId);
    if (awaitingCheckinId) {
      this.history.replace(`/checkins/${awaitingCheckinId}`);
      return;
    }

    this.checkin = new CheckIn(await fetchModel(
      endpoints.PERFORMANCE.CYCLE_CHECKIN.with(cycleId),
      types.PERFORMANCE.CHECKIN
    ));

    const questions = _.map(this.checkin.answers, 'question');
    await setupAutosaveDraft(
      this.checkin,
      {id: cycleId, type: types.PERFORMANCE.CHECKIN}
    );
    this.checkin.regenerateAnswersForQuestions(questions);
  }

  async findAwaitingCheckinId(cycleId, reviewerId) {
    const checkinRelations = await fetchModels(
      endpoints.PERFORMANCE.REVIEWERS_FOR_CYCLE.with(auth.employee.id, cycleId),
      types.PERFORMANCE.CHECKIN_RELATIONS
    );
    const relation = _.find(checkinRelations, {reviewer: {id: reviewerId}});

    return relation && relation.status === 'awaiting' ? relation.lastCheckinId : null;
  }

  updateAnswerContent(e, answer) {
    answer.content = e.target.value;

    this.checkin.autosaver.autosave();
  }

  async postCheckIn(checkin, cycleId) {
    return postModel(
      endpoints.PERFORMANCE.CYCLE_CHECKIN.with(cycleId),
      types.PERFORMANCE.CHECKIN,
      checkin.toJS()
    );
  }

  onSubmit = async () => {
    this.checkin.merge({reviewerEmployeeId: this.match.params.reviewerId});

    const {model, errors = {}} = await this.postCheckIn(this.checkin, this.match.params.cycleId);
    this.errors = errors;
    if (model) {
      this.history.push('/checkins');
    }
  };
}

export default MyCheckInResponseContainerState;
